import Color from "color";
import styled from "styled-components";
import { WHITE } from "../../../theme/colors";
import { unit } from "../../../theme/metrics";
import { typeBodySm } from "../../../theme/typography";

export const StyledContainer = styled.div`
  position: relative;
`;

export const StyledSuggestions = styled.ul<{ $open: boolean }>`
  background-color: ${WHITE};
  position: absolute;
  visibility: ${({ $open }) => $open ? 'visible' : 'hidden'};
  top: 100%;
  width: 100%;
  left: 0;
	padding: ${unit(2)} ${unit(3)};
  color: ${({ theme }) => theme.primary};
  border-left: 1px solid ${({ theme }) => Color(theme.primary).alpha(0.3).string()};
  border-right: 1px solid ${({ theme }) => Color(theme.primary).alpha(0.3).string()};
  border-bottom: 1px solid ${({ theme }) => Color(theme.primary).alpha(0.3).string()};
  ${typeBodySm}
  display: flex;
  flex-direction: column;
  gap: ${unit(2)};
  z-index: 2;

  li{
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover{
			opacity: 0.8;
		}
  }
`;